import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getOrderIdentifier)?_c(VContainer,{staticClass:"grey lighten-4"},[_c('show-order',{attrs:{"identifier":_vm.getOrderIdentifier}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }